





import { Vue, Component } from 'vue-property-decorator';
@Component({
  name: 'v-notification'
})
export default class VNotification extends Vue {}
